import React from 'react';

function Error() {
    return (
        <>
            <meta httpEquiv="refresh" content="0; url=/" />
        </>
    );
}

export default Error;
